import React from 'react'
import { Box, Divider, Text } from '@chakra-ui/react'
import colors from 'theme/colors.theme'
import { getValidArray } from 'utils/common'
import { ERouteName, SidebarItem } from '../../constants'
import { isSidebarItemActive, useActiveSidebarPath } from '../../sidebar-active-path'
import MenuItem from '../MenuItem'

interface IAppMenuItemProps {
  item: SidebarItem
  index: number
  isCondensed: boolean
  isBasicUser: boolean
}

const AppMenuItem = ({ item, index, isCondensed, isBasicUser }: IAppMenuItemProps) => {
  // At most one row in the whole sidebar is selected — see sidebar-active-path.
  const activePath = useActiveSidebarPath()
  const isActive = isSidebarItemActive(item, activePath)
  const children = item?.children
  const renderAsSection = !isBasicUser && item.name !== ERouteName.DASHBOARD && !!children

  return (
    <React.Fragment key={`${item.path}-${index}-fragment`}>
      {item?.header && (
        <Box
          as="li"
          listStyleType="none"
          key={`${index}-header`}
          color="white"
          letterSpacing="0.05em"
          fontSize="xs"
          fontWeight={700}
          textTransform="uppercase"
          padding="12px"
        >
          {item.header}
        </Box>
      )}
      {!renderAsSection ? (
        <MenuItem item={item} isActive={isActive} isCondensed={isCondensed} />
      ) : (
        <>
          {!isCondensed && (
            <Text
              marginTop="12px"
              marginBottom="8px"
              padding="0 12px"
              fontFamily="Poppins"
              fontSize="xs"
              fontWeight={600}
              color={colors.whiteAlpha[600]}
              lineHeight="normal"
              letterSpacing="1.2px"
            >
              {item.name.toUpperCase()}
            </Text>
          )}
          {isCondensed && <Divider borderColor="whiteAlpha.500" marginLeft={4} width={10} marginY="12px" />}
          {getValidArray(children).map((child, idx) => {
            const isChildActive = isSidebarItemActive(child, activePath)
            return (
              <MenuItem
                key={`${child.path}-${idx}`}
                item={child}
                isActive={isChildActive}
                isCondensed={isCondensed}
              />
            )
          })}
        </>
      )}
    </React.Fragment>
  )
}

export default AppMenuItem
